export const getStyled = (theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },

  buttonProgress: {
    color: theme.custom.colors.confirmButton,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },

  tab: {
    color: `${theme.custom.colors.text} !important`,
    backgroundColor: theme.custom.colors.defaultBackground,

    '& .MuiTab-root': {
      color: '#999999',
    },
    '& .Mui-selected': {
      color: `${theme.custom.colors.text} !important`,
    },
    '& .MuiTabs-indicator': {
      backgroundColor: `${theme.custom.colors.text} !important`,
    },
  },

  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },

  timePickerField: {
    '& .MuiInputBase-input': {
      color: theme.custom.colors.text,
    },

    '& .MuiInputLabel-root': {
      color: theme.custom.colors.text,
    },

    '& .MuiInputLabelRoot.Mui-focused': {
      color: theme.custom.colors.text,
    },

    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: theme.custom.colors.text,
      },
      '&:hover fieldset': {
        borderColor: theme.custom.colors.text,
      },
      '&.MuiFocused fieldset': {
        borderColor: theme.custom.colors.text,
      },
    },

    '& .MuiSvgIcon-root': {
      color: theme.custom.colors.text,
    },
  },

  menuProps: {
    PaperProps: {
      sx: {
        backgroundColor: theme.custom.colors.defaultBackground,
        color: theme.custom.colors.text,
      },
    },
  },

  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },

  avatar: {
    width: theme.spacing(12),
    height: theme.spacing(12),
    margin: theme.spacing(2),
    cursor: 'pointer',
    borderRadius: '50%',
    border: '2px solid #ccc',
  },

  updateDiv: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },

  updateInput: {
    display: 'none',
  },

  updateLabel: {
    padding: theme.spacing(1),
    margin: theme.spacing(1),
    textTransform: 'uppercase',
    textAlign: 'center',
    cursor: 'pointer',
    border: '2px solid #ccc',
    borderRadius: '5px',
    minWidth: 160,
    fontWeight: 'bold',
    color: '#555',
  },

  errorUpdate: {
    border: '2px solid red',
  },

  errorText: {
    color: 'red',
    fontSize: '0.8rem',
    fontWeight: 'bold',
  },

  on: {
    color: theme.custom.colors.confirmButton,
    fontSize: '20px',
  },

  off: {
    color: theme.custom.colors.disabledButton,
    fontSize: '20px',
  },
});
